"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modals = void 0;
const micromodal_1 = __importDefault(require("micromodal"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const modals = () => {
    let modalElement = document.querySelectorAll('.modal');
    if (!modalElement) {
        return;
    }
    micromodal_1.default.init({
        disableScroll: true,
        disableFocus: true,
    });
    let hasCookie = js_cookie_1.default.get('eligibility-criteria') === 'closed';
    if (document.getElementById('modal-eligibility') && !hasCookie) {
        micromodal_1.default.show('modal-eligibility', {
            disableScroll: true,
            disableFocus: true,
            onClose: modal => js_cookie_1.default.set('eligibility-criteria', 'closed', { expires: 28 })
        });
    }
};
exports.modals = modals;
